import React from 'react'
import { Box, Typography } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { StaffBenefitForm } from '../component/staff-benefit/StaffBenefitForm'
import { Navbar } from '../component/shared/Navbar'
import { AdminMenu } from '../component/admin/AdminMenu'
import { AdminXsMenu } from '../component/admin/AdminXsMenu'

export const CreateStaffBenefit = () => {
  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Create Staff Benefit</title>
      </Helmet>
      <Navbar />
      <Box display={{ xs: 'block', md: 'flex' }}>
        <AdminMenu />
        <Box overflow='hidden' width='100%' sx={{ p: { xs: 1 } }} mb={{ xs: 2, md: 10 }}>
          <Box display='flex' my={3} justifyContent='space-between'>
            <Typography variant='h1'>Create New Staff Benefit</Typography>
            <AdminXsMenu />
          </Box>
          <StaffBenefitForm />
        </Box>
      </Box>
    </>
  )
}
